import { BaseFloatDataChannel } from "./BaseDataChannel";

export class OdomChannel extends BaseFloatDataChannel {
  public getConfiguration() {
    return {
      name: 'odom'
    };
  }
}